import { render, staticRenderFns } from "./AlertsManagementView.vue?vue&type=template&id=4a13c685&scoped=true"
import script from "./AlertsManagementView.vue?vue&type=script&lang=js"
export * from "./AlertsManagementView.vue?vue&type=script&lang=js"
import style0 from "./AlertsManagementView.vue?vue&type=style&index=0&id=4a13c685&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a13c685",
  null
  
)

export default component.exports